import { CSSProperties, useMemo } from 'react';
import { useSelector } from '_common/hooks';
import styles from './TooltipWidget.module.scss';
import { StandardTooltipWidgetView, TooltipApprovedWidgetView } from '../..';

type TooltipWidgetProps = {
  testId: string;
  content: string;
  shortcut?: string;
  userId?: UserId;
  offsets: Rect & { leftWithBounds?: number };
  isPageLayout: boolean;
  isFieldInMultiline: boolean;
  forceVertical?: boolean;
  widgetPositionRect?: Rect;
  sectionWidth: number;
};

/* When editor is set to layout mode 'PAGE' the widgetContainer is set to the midlle of the page
    so we need to take in account another variables to position this tooltipWidgetContainer correctly.
    But when is in 'web' layout mode the orign point are on top right, so the viewPort values dont need to 
    be adjusted. 
 */

const TooltipWidgetView = ({
  testId,
  shortcut,
  userId,
  content,
  offsets,
  isFieldInMultiline,
  forceVertical,
  isPageLayout,
  widgetPositionRect,
  sectionWidth,
}: TooltipWidgetProps) => {
  const zoom = useSelector((state) => state.editor.status.zoom);

  const style = useMemo<CSSProperties>(() => {
    const newStyle: CSSProperties = {};
    let widgetContainerLeftOffset = 0;
    if (isPageLayout) {
      widgetContainerLeftOffset = widgetPositionRect?.left ?? 0;
    }

    if (isFieldInMultiline) {
      newStyle.top = offsets.top + offsets.height / 2 / zoom;

      if (isPageLayout) {
        const scrollOffset = document.getElementById('EditorRoot')?.scrollLeft ?? 0;
        newStyle.left = sectionWidth / 2 + scrollOffset / zoom;
      } else {
        newStyle.left = sectionWidth;
      }
    } else {
      if (forceVertical) {
        newStyle.top = offsets.top + offsets.height / 2 / zoom;
      } else {
        newStyle.top = offsets.top;
      }
      if (isPageLayout) {
        const scrollOffset = document.getElementById('EditorRoot')?.scrollLeft ?? 0;
        newStyle.left = offsets.left - widgetContainerLeftOffset - scrollOffset;
      } else {
        newStyle.left = offsets.left;
      }
      newStyle.width = offsets.width / zoom;
    }

    return newStyle;
  }, []);

  return userId ? (
    <TooltipApprovedWidgetView userId={userId} content={content} testId={testId}>
      <div style={style} className={styles.container}></div>
    </TooltipApprovedWidgetView>
  ) : (
    <StandardTooltipWidgetView
      content={content}
      testId={testId}
      shortcut={shortcut}
      isFieldInMultiline={isFieldInMultiline}
    >
      <div style={style} className={styles.container}></div>
    </StandardTooltipWidgetView>
  );
};

export default TooltipWidgetView;
